var AccountSettingsBuilder = /** @class */ (function () {
    function AccountSettingsBuilder() {
        this.accountSettings = {
            name: 'Wix',
            timezone: 'UTC',
            locales: ['en', 'ru']
        };
    }
    AccountSettingsBuilder.prototype.withName = function (name) {
        this.accountSettings.name = name;
        return this;
    };
    AccountSettingsBuilder.prototype.withLocales = function (locales) {
        this.accountSettings.locales = locales;
        return this;
    };
    AccountSettingsBuilder.prototype.withTimezone = function (timezone) {
        this.accountSettings.timezone = timezone;
        return this;
    };
    AccountSettingsBuilder.prototype.build = function () {
        return this.accountSettings;
    };
    return AccountSettingsBuilder;
}());
export { AccountSettingsBuilder };
//# sourceMappingURL=account-settings.builder.js.map